// extracted by mini-css-extract-plugin
export default {"mainContainer":"SearchBar_mainContainer__tpu6G","searchIcon":"SearchBar_searchIcon__Ixz3b","input":"SearchBar_input__e6-Cc","clearIcon":"SearchBar_clearIcon__y67Zl"};